module.exports = __webpack_public_path__ + "static/media/content.c5ea55b7.md";